import api from "./axios";
import { apiPaths } from "./paths";
import type { ApiMessage, User } from "@/types";

const apiOrigin = (process.env.API_URL || "").replace(/\/$/, "");

export const getGoogleAuthUrl = () => `${apiOrigin}/api${apiPaths.auth.google}`;

export const logout = () =>
  api.post<ApiMessage>(apiPaths.auth.logout).then((r) => r.data);

/** Current session user (subset of profile fields used by auth state). */
export const getMe = () =>
  api.get<User>(apiPaths.users.me).then((r) => ({
    id: r.data.id,
    email: r.data.email,
  }));

export const deleteMyAccount = () =>
  api.delete<ApiMessage>(apiPaths.users.me).then((r) => r.data);
